<template>
  <div id="MatchResultsContent">
    <Modal @close="back()">
      <template slot="body">
        <div id="lastHand">
          <div v-for="player in lastHand.players" :key="player.id" :class="{winner: player.id == lastHand.winner}">
            <h3>{{ player.name }}</h3>
            <Card class="card" :cardId="player.previous_card"/>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal";
import { mapGetters } from "vuex";
import Card from "@/components/Card";

export default {
  name: "LastHand",
  components: {
    Modal,
    Card
  },
  computed: {
    ...mapGetters({
      lastHand: "game/lastHand"
    })
  },
  methods: {
    back() {
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
#lastHand {
  display: flex;
  justify-content: space-between;
}
.form-button {
    padding: 0em;
    margin: 1em;
}
.winner {
  border: 3px dashed black;
  padding: 5px;
}
</style>
